import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Stockgrid.css';
import '../../Shared/Searchbar.css'; // Import your CSS file
import { useNavigate } from 'react-router-dom';
import GoCast from '../../Images/GoCast.png'

function Stock_grid() {

    // Navigation To Another Page
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false); // Loading GIF

    // Search-bar
    const [searchOpen, setSearchOpen] = useState(false);
    // Table visibility
    const [tableVisible, setTableVisible] = useState(true);

    //        API CODE
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed

    const [originalApiData, setOriginalApiData] = useState([]);
    const [filter, setFilter] = useState(''); // Element ID Filter
    const [selectedFilter, setSelectedFilter] = useState('');

    const fetchData = async () => {
        setIsLoading(true); // Load GIF
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl = 'https://77.92.189.102/iitprecastvertical/api/v1/Ice.BO.UD103Svc/UD103s'; // Adjust the URL as needed

        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData(data.value);
                setOriginalApiData(data.value);
                setIsLoading(false); // Loading GIF
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []); // Fetch data on component mount

    const handleFilterChange = (e) => {
        const inputValue = e.target.value.toLowerCase(); // Convert input value to lowercase
        setFilter(inputValue);

        // If the input value is cleared, reset apiData to the original data
        if (inputValue === '') {
            setApiData(originalApiData);
        } else {
            // Filter apiData based on the input value, ensuring ElementID is defined
            // Convert item.Key1 to lowercase for case-insensitive comparison
            const filteredData = apiData.filter(item => item.Key1 && item.Key1.toLowerCase().includes(inputValue));
            setApiData(filteredData.map(item => ({...item }))); // Update modifiedData with filtered data
        }
    };

    const filteredData = selectedFilter ? apiData.filter(item => item.ShortChar03 === selectedFilter) : apiData;
    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = filteredData.slice(startIndex, endIndex);

        return currentItems.map((item, index) => (
            <tr>
                <td onClick={() => navigate(`/stockgrid/offdetails/${item.Key1}?Key2=${item.Key2}&Key3=${item.Key3}&Key4=${item.Key4}&Key5=${item.Key5}&Company=${item.Company}`)}>{item.Key1}</td>
                <td>{item.Character01}</td>
                <td>{item.ShortChar03}</td>
            </tr>
        ));
    };
    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Search Toggle
    const toggleSearch = () => {
        setSearchOpen(!searchOpen);
    }

    // Toggle table visibility
    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    }

    return (
        <div className='APretention'>
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className='card rebartable'>
                <h2> Stock Offload</h2>
                <div className="card-header-apretention">
                    <button type="button" className="toggle-table-icon" onClick={toggleTableVisibility}>
                        <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
                    </button>
                    <h4 className='panel-title-stock'>Parent</h4>
                    <div className='dropdown'>
                        <select
                            className="Elementidinput"
                            type="text"
                            name="optionlist"
                            onChange={(e) => setSelectedFilter(e.target.value)}
                        >
                            <option value="" selected >ALL</option>
                            <option>In Transit</option>
                            <option>Open</option>
                            <option>Closed</option>
                        </select>
                    </div>
                    <div className='Element-id-container-stock'>

                        <input type='text' placeholder='Load' className='Elementidinput-stock' onChange={handleFilterChange} />
                    </div>

                </div>
                {/* Conditionally render the table */}
                {tableVisible && (
                    <div className="card-body" style={{ overflowY: 'scroll' }}>
                        <div class="table-responsive-sm">
                            <div className="scrollable-table-body">
                                <table className="table table-bordered">
                                    {/* Table content */}
                                    <thead className='table-primary'>
                                        <tr className='bg-primary text-white text-nowrap'>
                                            <th>Load ID</th>
                                            <th>Description</th>
                                            <th>Load Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderTableRows()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="pagination">
                            <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                            <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>

                    </div>

                )}
            </div>
        </div>
    );
}

export default Stock_grid;
